import { render, staticRenderFns } from "./SupplierRequestPage.vue?vue&type=template&id=79edf0f2&scoped=true&lang=pug&"
import script from "./SupplierRequestPage.vue?vue&type=script&lang=js&"
export * from "./SupplierRequestPage.vue?vue&type=script&lang=js&"
import style0 from "./SupplierRequestPage.vue?vue&type=style&index=0&id=79edf0f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79edf0f2",
  null
  
)

export default component.exports